import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import config from '../../config'
import './style'

class Main extends Component {
	render() {
		return (
			<div className="row">
				<div className="col-1 sm-hidden" />
				<div className="score-page col-4 col-sm-4 col-xs-2">
					<h1 className="heading-2-type-1 font-medium">Try tools</h1>
					<div className="description font-regular text-3-type-3">
						Explore our interfaces for images and text annotation, test your skills and get a score.
					</div>
					<div className="buttons main-buttons">
						<Link
							className="bttn bttn-type__default bttn-size__middle"
							to={config.routes.demo.label.path}
						>
							Classes
						</Link>

						<Link
							className="bttn bttn-type__default bttn-size__middle"
							to={config.routes.demo.aabb.path}
						>
							Bounding boxes
						</Link>

						<Link
							className="bttn bttn-type__default bttn-size__middle"
							to={config.routes.demo.segmentation.path}
						>
							Polygons
						</Link>

						<Link
							className="bttn bttn-type__default bttn-size__middle"
							to={config.routes.demo.ocr.path}
						>
							Text input
						</Link>

						<Link
							className="bttn bttn-type__default bttn-size__middle"
							to={config.routes.demo.textcategorization.path}
						>
							Text segmentation
						</Link>
					</div>
				</div>
			</div>
		)
	}
}

export default Main
